// extracted by mini-css-extract-plugin
export var RichText = "Q_cK";
export var aniBgLoading = "Q_f";
export var aniSpin = "Q_d";
export var headingStyles = "Q_cM";
export var imageStyles = "Q_cN";
export var listStyles = "Q_cL";
export var tableStyles = "Q_cP";